/**
 * Login Page
 * Authentication page with login form
 */

import React from 'react';
import { useSearchParams } from 'react-router-dom';
import LoginForm from '../components/auth/LoginForm';
import { APP_NAME } from '../utils/constants';

const Login: React.FC = () => {
  const [searchParams] = useSearchParams();
  const expired = searchParams.get('expired') === 'true';
  const reason = searchParams.get('reason') || 'Your session has expired';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Header */}
        <div className="text-center">
          <img
            src="/logowhite.png"
            alt="U.S. LawShield Logo"
            className="mx-auto h-24 w-auto mb-4"
          />
          <h1 className="text-3xl font-bold text-gray-900">{APP_NAME}</h1>
          <h2 className="mt-6 text-2xl font-semibold text-gray-900">
            Sign in to your account
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Enter your credentials to access your account
          </p>
        </div>

        {/* Session Expired Message */}
        {expired && (
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm text-yellow-700">
                  {reason}. Please sign in again.
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Login Form */}
        <div className="mt-8 bg-white py-8 px-6 shadow-lg rounded-lg">
          <LoginForm />
        </div>

        {/* Footer */}
        <div className="text-center text-sm text-gray-600">
          <p>
            Need help? <a href="/support" className="text-blue-600 hover:text-blue-700">Contact Support</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
